import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../../libs'
import { VerificationRequest } from './types'

export const verificationRequestMounted = createEvent<string>()

export const getVerificationRequests = fx<string, VerificationRequest[]>({
  method: 'GET',
  url: `/verification?where{"clientId":"1"}`,
})

export const $verificationRequest = restore<VerificationRequest[]>(
  getVerificationRequests.doneData.map((doneData) => doneData.body),
  [],
)

sample({
  clock: [verificationRequestMounted],
  fn: (id) => {
    return {
      url: `/verification/${id}/duplicates`,
    }
  },
  target: [getVerificationRequests],
})
